module.exports = __webpack_public_path__ + "img/t2-c5.667acf61.png";